import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: false,
});

export default function SolarPanel() {
    const { useLang } = useGlobal();
    const { t } = useLang('400wrigidsolarpanel');
    const webpUrl = '/media/solarpanel_400w_rigid/pc/';

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            {/* banner */}
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule
                    data={[
                        {
                            bgImgs: ['banner.webp', 'banner.jpg'],
                            title: t('solarpanels_400w_rigid.title'),
                            des: t('solarpanels_400w_rigid.desc'),
                        },
                    ]}
                    config={{ isShowLogo: false, theme: 'white', webpUrl }}
                />
            </div>
            <Content />
        </div>
    );
}
